import { useState } from 'react'
import { onAddToTrolleyModalOpen } from '@/javascript/components/CreditOptions/credit-options.tracking'

// Fulfilment pass trolley status constants
export const BASKET_API_STATUS = {
  IDLE: 'idle',
  SUCCESS: 'success',
  ERROR: 'error',
  ALREADY_IN_BASKET: 'already_in_basket'
}

const BASKET_API_PATH = '/basket-api/v1/basket/items'
const FULFILMENT_PASS_SKU = '7162305'
const FULFILMENT_PASS_QUANTITY = 1

export const useAddFulfilmentPass = () => {
  const [basketApiStatus, setBasketApiStatus] = useState(BASKET_API_STATUS.IDLE)
  const [isAddingPassToTrolley, setIsAddingPassToTrolley] = useState(false)

  const addPassToTrolley = async () => {
    try {
      setIsAddingPassToTrolley(true)

      const response = await fetch(BASKET_API_PATH, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          productId: FULFILMENT_PASS_SKU,
          quantity: FULFILMENT_PASS_QUANTITY
        })
      })

      if (!response.ok) {
        const errorData = await response.json()
        const error = new Error(`HTTP error! status: ${response.status}`)
        error.status = response.status
        error.data = errorData
        throw error
      }

      setBasketApiStatus(BASKET_API_STATUS.SUCCESS)

      onAddToTrolleyModalOpen(
        { id: FULFILMENT_PASS_SKU, price: 40, quantity: FULFILMENT_PASS_QUANTITY },
        { clickOrigin: 'PDP:argosPlusDrawerATT' },
        window
      )
    } catch (error) {
      const errorType = error?.data?.error

      if (errorType === 'EXCEEDS_MAX_ALLOWED_QUANTITY') {
        setBasketApiStatus(BASKET_API_STATUS.ALREADY_IN_BASKET)
      } else {
        console.error('Failed to add Argos Plus to trolley:', error)
        setBasketApiStatus(BASKET_API_STATUS.ERROR)
      }
    } finally {
      setIsAddingPassToTrolley(false)
    }
  }

  return {
    basketApiStatus,
    setBasketApiStatus,
    isAddingPassToTrolley,
    addPassToTrolley,
    BASKET_API_STATUS
  }
}
